export const FETCH_CITY_URL = `${process.env.REACT_APP_API_URL}/cities`;
export const CREATE_CITY_URL = `${process.env.REACT_APP_API_URL}/cities/create`;
export const UPDATE_CITY_URL = `${process.env.REACT_APP_API_URL}/cities`;
// export const QUERY_CITY_URL = `${process.env.REACT_APP_API_URL}/cities/query`;
